function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { openInNewTabProps } from "../../../../../constants";
import { CompleteKYCIcon } from "../../BusinessOnboardingWidget.icons";
import { ActionButton, StepLayout } from "../../BusinessOnboardingWidget.utils";
import styles from "../CompleteKYC/CompleteKYC.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const VerifyYourIdentity = props => {
  const {
    kycStepComplete,
    connectBankAccountStepComplete
  } = props.extraProps;
  const baseTestId = 'onboarding-widget-verifyYourIdentity';
  const disabled = !kycStepComplete || !connectBankAccountStepComplete;
  const title = props.isComplete ? "You've successfully activated your account" : 'Verify your identity to activate your account';
  const subtitle = props.isComplete ? 'You can now process payments through Anchor.' : 'Identity verification is required to process payments through Anchor. Schedule a quick 5-minute video call below and have your picture ID ready.';
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "verifyYourIdentity",
    title: /*#__PURE__*/_jsx("div", {
      "data-testid": "".concat(baseTestId).concat(props.isComplete ? '-complete' : '', "-title"),
      children: title
    }),
    subtitle: subtitle,
    actions: props.isComplete ? null : /*#__PURE__*/_jsx("div", {
      "data-testid": "".concat(baseTestId, "-actions"),
      className: styles.actionsWrapper,
      children: /*#__PURE__*/_jsx(ActionButton, _objectSpread(_objectSpread({
        as: "a",
        href: "https://book.avoma.com/anchor/enable-payments/"
      }, openInNewTabProps), {}, {
        tooltip: disabled ? {
          title: /*#__PURE__*/_jsx("div", {
            "data-testid": "".concat(baseTestId, "-disabled-tooltip"),
            children: "To verify your identity, ensure your bank account is connected and your business verification is complete."
          })
        } : undefined,
        "data-testid": "".concat(baseTestId).concat(disabled ? '-disabled' : '', "-button"),
        disabled: disabled,
        children: "Verify identity"
      }))
    }),
    icon: /*#__PURE__*/_jsx(CompleteKYCIcon, {})
  });
};
export default VerifyYourIdentity;